import React from "react";
import {connect} from "react-redux";
import {ModalTypes} from "../../../tools/StaticTypes";
import {
    deleteModalData,
    setLoaderModalData,
    setModalData
} from "../../../store/globalState/actionCreators/globalState_AppActionCreator";
import DropFileComponent from "../../tools/DropFileComponent/DropFileComponent";
import {
    createPreviewBySelectDocument,
    updateDocFile
} from "../../../store/documents/actionCreators/document_PreviewActionCreator";
import {DocFilePart} from "../../../tools/API_NEW/ServerTypes";
import {store} from "../../../index";
import {API} from "../../../tools/API_NEW/API";

class ModalUpdateFile extends React.Component{
    constructor(props){
        super(props)
        this.state={
            contentOnHover : false,
            file: null,
            showOriginalFilesTooltipShow:false,
            closeOnHover:false,
            OriginalFileError: false,
            filePart: this.props.modal.data.activeView ?? this.props.modal.data.preview.activeView,
        }
        this.hide = this.hide.bind(this);
        this.hideOutSide = this.hideOutSide.bind(this);
        this.confirmChanges=this.confirmChanges.bind(this);
        this.send=this.send.bind(this);

        this.showOriginalFilesRef=React.createRef();
        this.fileRef = React.createRef();
    }

    hide() {
        this.props.deleteModalData({modalId: this.props.modal.id})
    }

    hideOutSide() { // скрывать при клике вне окна
        if(!this.state.contentOnHover) {
            this.props.deleteModalData({modalId: this.props.modal.id})
        }
    }
   async confirmChanges() {
       // проверка файлов
       this.props.setLoaderModalData({
           data: {
               content: "Загрузка документа...",
               disableButton: true,
               fullBackground: false,
               gif: "documents",
               key: "UpdateFile53"
           }
       });

       let errorText = ``
       if (this.state.filePart.toLowerCase() === 'original') {
           // заполнение файлов
           if (this.state.file == null) {
               errorText = `Ошибка заполнения: <br/>Необходимо выбрать оригинальный файл документа (.pdf)`
           }
           // расширение файла
           if (this.state.file.name.toLowerCase().split('.').pop() !== "pdf") {
               errorText = `Ошибка заполнения: <br/>Оригинальный файл документа должен иметь расширение .pdf`
           }
           // размер файла
           if (this.state.file.size > 1024 * 1024 * 250) {
               errorText = `Ошибка заполнения: <br/>Максимальный размер оригинального файла документа не более 250мб`
           }
       }

       if (this.state.filePart.toLowerCase() === 'preview') {
           if (this.state.file == null) {
               errorText = `Ошибка заполнения: <br/>Необходимо выбрать оригинальный файл документа (.png)`
           }
           if (this.state.file.name.split('.').pop() !== "png") {
               errorText = `Ошибка заполнения: <br/>Файл документа должен иметь расширение .png`
           }
       }

       if (this.state.filePart.toLowerCase() === 'content') {
           if (this.state.file == null) {
               errorText = `Ошибка заполнения: <br/>Необходимо выбрать оригинальный файл документа (.txt, .text)`
           }
           if (this.state.file.name.split('.').pop() !== "txt" && this.state.file.name.split('.').pop() !== "text") {
               errorText = `Ошибка заполнения: <br/>Файл документа должен иметь расширение .txt, .text`
           }
       }

       if (errorText) {
           this.props.addModalData({
               name: ModalTypes.app.info,
               data: {
                   type: "fail",
                   content: errorText
               }
           });
           this.props.setLoaderModalData({
               data: {
                   keyDeleted: "UpdateFile102"
               }
           });
           return;
       }
        await this.send()
    }

   async send(){
        let part=''
        let file=this.state.file

        if(this.state.filePart.toLowerCase()==='original'){
            part=DocFilePart.File
        } else if(this.state.filePart.toLowerCase()==='preview'){
            part=DocFilePart.Preview

            // await API.documents().resetDocPreviewFile({
            //     id: this.props.modal.data.activeFile.id,
            //     // id: this.props.activeFile.id,
            //     isAvailable:true,
            // })


        } else if(this.state.filePart.toLowerCase()==='content'){
            part=DocFilePart.Text
        }

        await this.props.updateDocFile({
            IdDocFile: this.props.modal.data.activeFile?.id,
            IdDoc: this.props.modal.data.activeRow,
            File: file,
            Part: part,
        })

       if (this.props.modal.data.callback) this.props.modal.data.callback();
       this.props.setModalData({
           name: ModalTypes.app.info,
           data: {type: "success", content: `Файл документа успешно обновлен!`}
       });

       this.props.setLoaderModalData({keyDeleted: "UpdateFile102"});

       this.props.deleteModalData({modalId: this.props.modal.id})
    }

    render(){
        let modalStyle = {
            display : "block",
            backgroundColor: "#061c3e66",
        };
        let containerStyle={
            display:'flex',
            width:'100%',
            height:'100%',
        }
        let close={
            cursor:'pointer',
            color:"var(--originaltwo)"
        }
        if(!this.state.closeOnHover){
            close={}
        }
        return(
            <div className="modal fade show" style={modalStyle} onClick={this.hideOutSide}>
                <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered"
                     style={containerStyle}
                     onMouseEnter={() => {this.setState({ contentOnHover : true})}}
                     onMouseLeave={() => {this.setState({ contentOnHover : false})}}>
                    <div className="modal-content" style={{borderRadius:"25px",height:'58%',}}>
                        <div className="modal-header">
                            <h5 className="modal-title">Обновление файла</h5>
                            <div
                                onMouseEnter={()=>this.setState({closeOnHover:true})}
                                onMouseLeave={()=>this.setState({closeOnHover:false})}>
                                <i className="bi bi-x-lg" onClick={this.hide} style={close}></i>
                            </div>
                        </div>
                        <div className="modal-body" style={{display:'flex',flexDirection:'column'}}>
                            <div className="discription" style={{display:'flex',flexDirection:'column',marginBottom:20}}>
                                <label className="discription_title" style={{}}>Название:</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    placeholder={this.props.modal.data.activeFile?.name}
                                    // placeholder={this.props.activeFile?.name}
                                    disabled
                                    style={{flexGrow:1,}}
                                />
                            </div>
                            <div className="newFile" style={{display:'flex',flexDirection:'column',}}>
                                {/*<div className="newFile_title" style={{}}>Файл:</div>*/}
                                <div style={{display:'flex',flexDirection:'column'}}>
                                    { this.state.filePart.toLowerCase()==="original" &&
                                        <div>
                                    <p className="my-4"><b>Оригинал (PDF)<sup
                                        style={{color: "#dc3545"}}>*</sup></b>
                                    </p>
                                        <DropFileComponent elemRef={this.fileRef}
                                                           name={"original"}
                                                           accept={"application/pdf"}
                                                           multiple={false}
                                                           setFiles={(file) => this.setState({file: file})}
                                                           value={this.state.file}
                                                           style={{}}
                                        />
                                        </div>
                                    }
                                    {
                                        this.state.filePart.toLowerCase()==="preview" &&
                                        <div>
                                            <p className="my-2 text-nowrap"><b>Файл предпросмотра
                                                (PNG)</b>
                                            </p>
                                            <DropFileComponent elemRef={this.fileRef}
                                                               name={"preview"}
                                                               accept={"image/png"}
                                                               multiple={false}
                                                               setFiles={(file) => this.setState({file: file})}
                                                               value={this.state.file}
                                            />
                                        </div>
                                    }
                                    {
                                        this.state.filePart.toLowerCase()==="content" &&
                                        <div>
                                            <p className="my-2 text-nowrap"><b>Файл содержимого(TEXT, TXT): </b>
                                            </p>
                                            <DropFileComponent elemRef={this.fileRef}
                                                               name={"content"}
                                                               accept={".text, .txt"}
                                                               multiple={false}
                                                               setFiles={(file) => this.setState({file: file})}
                                                               value={this.state.file}
                                            />
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer" style={{display:'flex',justifyContent:'flex-end'}}>
                            <div className="btn btn-secondary" data-dismiss="modal" onClick={this.hide}>Отмена</div>
                            <div className="btn btn-primary" style={{alignSelf:'stretch'}} onClick={this.confirmChanges}>Заменить</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const  mapStateToProps = state => {
    return {
        // activeFile:state.document.preview.activeFile,
        // activeRow:state.document.mainTable.activeRow?.Version,
        // preview: state.document.preview,
    }
}

const  mapDispatchToProps = {
    setModalData,
    deleteModalData,
    setLoaderModalData,
    updateDocFile,
    createPreviewBySelectDocument,
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalUpdateFile);
